var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.isShow}},[_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"block"},[_c('van-loading',{attrs:{"type":"spinner"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c72f632c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadingMask.vue
// module id = null
// module chunks = 